import React from 'react';
import { ActivityIcon, GlobeIcon, TagIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { images } from '../../data/landing';
export function Hero({
  ctaRef
}: {
  ctaRef: React.Ref<HTMLAnchorElement>;
}) {
  return <header className="bg-cream" data-id="element-151" data-mp="huo2y6tz4msk">
      <div className="mx-auto max-w-5xl px-5 pb-16 pt-8 text-center sm:pt-12" data-id="element-152" data-mp="hvqr46zwwb4s">
        <div className="inline-flex items-center gap-2.5 rounded-full bg-white py-1.5 pl-1.5 pr-4 ring-1 ring-navy-900/10" data-id="element-153" data-mp="mutxburmonec">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-navy-900" data-id="element-154" data-mp="qub2en357iiz">
            <ActivityIcon className="h-4 w-4 text-brand-400" aria-hidden="true" data-id="element-155" data-mp="vnne5wmq3uub" />
          </span>
          <span className="font-display text-base font-extrabold text-navy-900" data-id="element-156" data-mp="10k448wdhgja1">Hernia Clinical Playbook™</span>
        </div>

        <h1 className="mx-auto mt-6 max-w-4xl text-balance font-display text-[2.15rem] font-black leading-[1.08] text-navy-900 sm:text-5xl lg:text-[3.6rem]" data-id="element-157" data-mp="15ifcx3s1knqo">
          Structure the Initial Assessment &amp; Treatment Plan for a Disc Herniation Patient in{' '}
          <em className="italic text-brand-600" data-id="element-158" data-mp="4nogq07hnang">15&nbsp;Minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-navy-900/75 sm:text-xl" data-id="element-159" data-mp="3vuhip6a3vdt1">
          A step-by-step clinical playbook designed to help you organize your assessment, clinical reasoning, and
          treatment planning with greater structure and confidence.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-navy-900/80 sm:text-lg" data-id="element-160" data-mp="nfh7rp2zylsj">
          Includes <strong className="text-navy-900" data-id="element-161" data-mp="inphzgro0k3g">6 Professional Volumes</strong> +{' '}
          <strong className="text-navy-900" data-id="element-162" data-mp="en5kgc36jegs">5 Exclusive Bonuses</strong> + Clinical Checklists + Decision Algorithms +
          Practical Tools.
        </p>

        <figure className="-mx-3 mt-8 sm:mx-0" data-id="element-163" data-mp="1b6378ryxqxqx">
          <img src={images.mockup} alt="Hernia Clinical Playbook: 6 volumes, 5 bonuses, checklists and templates" className="mx-auto w-full max-w-3xl" data-id="element-164" data-mp="16dju1w45u4mn" />
          <figcaption className="mx-auto mt-3 max-w-md font-display text-lg font-bold text-navy-900" data-id="element-165" data-mp="35ljrmlmrdv6k">
            The 6 Volumes &amp; 5 Bonuses Inside the Hernia Clinical Playbook™
          </figcaption>
        </figure>

        <CtaButton ref={ctaRef} className="mt-8" label="Get the Hernia Clinical Playbook™" sublabel="Instant Access · One-Time Payment of $27 · Lifetime Access · 7-Day Guarantee" data-id="element-166" data-mp="2vu5m9x84m15i" />

        <Countdown data-id="element-167" data-mp="2mvu0c8i7frje" />

        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-168" data-mp="2ms66f88ul345">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-ember-500 px-4 py-1.5 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-169" data-mp="27yt4ptww7cfn">
            <TagIcon className="h-4 w-4" aria-hidden="true" data-id="element-170" data-mp="65df90cjk3m9" />
            Special Launch Price
          </span>
          <p className="flex items-center gap-1.5 text-sm text-navy-900/70" data-id="element-171" data-mp="b586x6454x8d">
            <GlobeIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-172" data-mp="1vmr1i7ughpta" />
            Currency conversion is automatically adjusted according to your country.
          </p>
        </div>
      </div>
    </header>;
}